<template>
    <div class="course_box">
        <div class="sort">
            <span :class="{on: params.order === data.param}" @click="sortBtn(data.param, $event)" v-for="(data, idx) in sortList" v-bind:key="idx">{{data.name}}</span>
            <div class="complete_hide">
                <input type="checkbox" id="complete_off"  name="complete_off" @change="checkStatus($event)"> <label for="complete_off">찍은 스탬프 숨기기</label>
            </div>
        </div>
        <div class="area_box" v-if="areaList.length > 0">
            <div class="select">
              <input v-model="area" type="text" readonly @click="openPopup(selectVals1, '지역선택')">
            </div>
        </div>
        <ul class="list">
            <li v-for="(data, idx) in mainStampList" v-bind:key="idx" @click="stampDetail(data)">
                <div
                  class="box_lt"
                  :style="{ 'background-image': `url(${data.mingle_new_badge_image || data.mingle_badge_image})` }">
                    <img :class="(data.user_mingle_badge_get_stamp_yn === 'N')?'p_icon':'c_icon'" :src="iconImg(data.mingle_badge_type, data.user_mingle_badge_get_stamp_yn)" alt="course_icon">
                    <span v-if="data.mingle_badge_inte_point !== '0'">{{data.mingle_badge_inte_point}}P</span>
                    <span v-else-if="data.user_mingle_badge_get_stamp_yn === 'N' && setStamp()">{{data.user_mingle_badge_point}}P</span>
                    <div class="layer"></div>
                </div>
                <div class="box_rt">
                    <h2>{{data.info_badge_name}}</h2>
                    <p class="txt">
                      여기에서 {{parseFloat(data.distance).toFixed(2)}}km
                      <span class="star">
                        <img :src="starIcon(data.star_point)" alt="" />
                        {{(data.star_point === '0.0') ? '별점없음' : data.star_point}}
                      </span>
                    </p>
                    <div class="stamp_count">
                        <img class="stamp" src="@/assets/images/stamp_icon_2.png" alt="stamp">
                        <span class="stxt">{{stampKind(data)}}</span>
                        <span class="snum">{{data.mingle_stat_badge_count || 0}}</span>
                        <span v-if="data.mingle_badge_category === 'BICYCLE'" class="cycle">자전거</span>
                    </div>
                    <!-- <div class="position" v-if="(data.mingle_badge_type === 'STAMP' || (mingleCode === 'vSi8Z9QlNS5wushabGnrhA==' && data.mingle_badge_id !== '21526167') || mingleCode === 'xYwbII8pDWTT1VzPbK3E1g==') && data.user_mingle_badge_get_stamp_yn !== 'Y' && token" @click="stampAuth($event, data)">전자스탬프</div> -->
                    <div class="position" :class="stampIcon()" v-if="(data.mingle_badge_type === 'STAMP' || mingleCode === 'vSi8Z9QlNS5wushabGnrhA==' || mingleCode === 'xYwbII8pDWTT1VzPbK3E1g==') && data.user_mingle_badge_get_stamp_yn !== 'Y' && token" @click="nfcStampCheck($event, data)">전자스탬프</div>
                    <div class="stamp_badge" v-else-if="data.user_mingle_badge_get_stamp_yn === 'Y'" @click="stampClick($event ,data)">
                      <!-- <img src="@/assets/images/dummy_img/stamp.png" alt=""> -->
                      <img :src="data.mingle_stamp_image" alt="">
                    </div>
                    <div class="progress_box" v-if="progressOn(data)">
                        <div class="p_back">
                            <div class="progress" :style="{'width':progressWidth(data)}"></div>
                        </div>
                        <span>{{progressWidth(data)}}</span>
                    </div>
                </div>
            </li>
            <div class="loading_box" v-if="loadingMainList">
              <img src="@/assets/images/ajax-loader.gif" alt="loader">
            </div>
        </ul>
        <SelectPopup v-if="commonSelect.visible" @sendVal="changeSelect" />
    </div>
</template>
<script>
import { mapState } from 'vuex'
import * as appEvent from '@/assets/js/app_event.js'
import SelectPopup from '@/components/SelectPopup.vue'
export default {
  name: 'MainList',
  components: {
    SelectPopup
  },
  data () {
    return {
      sortList: [
        { name: '인기순', active: true, param: 'pop' },
        { name: '거리순', active: false, param: 'distance' },
        { name: '이름순', active: false, param: 'name' }
        // { name: '별점순', active: false, param: 'star' }
      ],
      params: {
        order: this.$cookie.get('listOrder') || 'pop',
        status: 'ALL',
        areaCode: '0',
        page: 1,
        view_count: 10
      },
      progressData: this.localData(),
      appVersion: '',
      appDevice: '',
      selectVals1: ['전체'],
      area: '전체'
    }
  },
  watch: {
    mingleCode () {
      this.$store.dispatch('loadAreaList')
      this.$store.dispatch('loadMingleVersionChk')
      this.$store.dispatch('loadMainData', this.params)
    },
    areaList () {
      if (this.selectVals1.length === 1) {
        this.selectVals1 = this.selectVals1.concat(this.areaList.map(v => v.mingle_area_title))
      }
    }
  },
  computed: {
    ...mapState(['mainStampList', 'areaList', 'mingleCode', 'token', 'stampCodeInfo', 'allStampCount', 'loadingMainList', 'commonSelect'])
  },
  methods: {
    openPopup (list, title) {
      document.body.classList.add('overhidden')
      this.$store.state.commonSelect.value = this.area
      this.$store.state.commonSelect.visible = true
      this.$store.state.commonSelect.list = list
      this.$store.state.commonSelect.title = title
    },
    changeSelect (val) {
      this.area = val
      this.params.page = 1
      const changeVal = this.areaList.filter(v => v.mingle_area_title === val)[0]
      this.params.areaCode = changeVal ? changeVal.mingle_area_code : '0'
      this.$store.dispatch('setAreaCode', this.params.areaCode)
      this.listCall()
    },
    stampClick (e, data) {
      e.stopPropagation()
      this.$store.state.getStampImage = data.mingle_stamp_image
      this.$store.state.getStampName = data.info_badge_name
      this.$store.state.getStampDate = data.user_mingle_badge_stamp_date
      this.$store.state.getStampWhence = data.mingle_badge_img_whence
      const openChk = this.$store.state.stampOpen
      this.$store.dispatch('loadStampPopup', openChk)
    },
    stampKind (data) {
      let stamp = ''
      if (data.mingle_badge_type === 'BADGE') {
        stamp = '방문 스탬프'
      } else if (data.mingle_badge_type === 'TRACK') {
        stamp = '코스 스탬프'
      } else {
        stamp = '전자 스탬프'
      }
      return stamp
    },
    iconImg (type, stamp) {
      let iType = ''
      if ((this.appDevice === 'A' && this.appVersion < 125) || (this.appDevice === 'I' && this.appVersion < 124)) {
        iType = `couse_icon_${type.toLowerCase()}`
      } else {
        if (type.toLowerCase() === 'stamp') {
          iType = `couse_icon_${type.toLowerCase()}_nfc`
        } else {
          iType = `couse_icon_${type.toLowerCase()}`
        }
      }
      if (stamp === 'Y') {
        iType = 'complete'
      }
      return require(`@/assets/images/${iType}.png`)
    },
    sortBtn (param, ev) {
      for (const i in this.sortList) {
        if (ev.target.className !== 'on') {
          this.sortList[i].active = false
          this.params.order = param
          this.$cookie.set('listOrder', param, 9999)
          if (ev.target.innerText === this.sortList[i].name) {
            this.sortList[i].active = true
            this.listCall()
          }
        }
      }
    },
    checkStatus (ev) {
      if (ev.target.checked) {
        this.params.status = 'FINISH'
      } else {
        this.params.status = 'ALL'
      }
      this.listCall()
    },
    setArea () {
      this.$store.dispatch('setAreaCode', this.params.areaCode)
      this.listCall()
    },
    listCall () {
      this.$store.state.lon = localStorage.getItem('setLon')
      this.$store.state.lat = localStorage.getItem('setLat')
      setTimeout(() => {
        this.params.page = 1
        // this.$store.dispatch('loadMainDataChange', this.params)
        this.$store.dispatch('loadMainData', this.params)
      }, 100)
    },
    stampDetail (sid) {
      if (sid.mingle_badge_id === '21524279') {
        // alert('코로나19 확산 예방을 위해, 고성 통일전망대가 잠정 폐쇄(2020년 2월 25일 ~ 무기한) 되었으므로 50코스 이용시 참고하여 주시기 바랍니다.')
        this.$store.state.wonjuPopup2.open = true
        this.$store.state.wonjuPopup2.data = sid
      } else {
        localStorage.stampDetail = JSON.stringify(sid)
        if (/Android/i.test(navigator.userAgent)) {
          // eslint-disable-next-line no-undef
          tranggle3.tranggle_callback('stamp_loc', `{lat:${sid.info_org_lat} ,lon:${sid.info_org_lon} ,badge_id:${sid.mingle_badge_id} }`)
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location = `tranggle_callback://stamp_loc?lat=${sid.info_org_lat}&lon=${sid.info_org_lon}&badge_Id=${sid.mingle_badge_id}`
        } else {
          return false
        }
      }
    },
    setStamp () {
      let tg = false
      this.stampCodeInfo.map((data) => {
        if (data.code === this.mingleCode && data.info === 'point') {
          tg = true
        } else if (data.code === this.mingleCode && data.info === 'number') {
          tg = false
        }
      })
      return tg
    },
    progressWidth (data) {
      let pdata = 0
      if (Object.keys(this.progressData).length) {
        this.progressData.content.map((val) => {
          if (data.mingle_badge_id === val.badge && val.rate > 0) {
            pdata = val.rate
          }
        })
      }
      return `${pdata}%`
    },
    progressOn (data) {
      let pOn = false
      if (Object.keys(this.progressData).length) {
        this.progressData.content.map((val) => {
          if (data.mingle_badge_id === val.badge && val.rate > 0) {
            pOn = true
          }
        })
      }
      return pOn
    },
    localData () {
      let val = {}
      if (/Android/i.test(navigator.userAgent) && localStorage.united_android) {
        val = JSON.parse(localStorage.united_android)
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent) && localStorage.united_ios) {
        val = JSON.parse(localStorage.united_ios)
      }
      return val
    },
    nfcStampCheck (e, data) {
      e.stopPropagation()
      if ((this.appDevice === 'A' && this.appVersion < 125) || (this.appDevice === 'I' && this.appVersion < 124)) {
        console.log('전자 스탬프')
        this.stampAuth(e, data)
      } else {
        console.log('NFC 스탬프')
        if (/Android/i.test(navigator.userAgent)) {
          // eslint-disable-next-line no-undef
          tranggle3.tranggle_callback('stamp_nfc_read', `{ badge_id:'${data.mingle_badge_id}', mingle_code:'${this.mingleCode}' }`)
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location = `tranggle_callback://stamp_nfc_read?badge_id=${data.mingle_badge_id}&mingle_code=${this.mingleCode}`
        } else {
          return false
        }
      }
    },
    stampIcon () {
      let name = ''
      if ((this.appDevice === 'A' && this.appVersion < 125) || (this.appDevice === 'I' && this.appVersion < 124)) {
        name = 'press'
      } else {
        name = 'nfc'
      }
      return name
    },
    stampAuth (e, data) {
      e.stopPropagation()
      // window.history.pushState({}, 'modal', '/modal')
      // this.$store.dispatch('loadBadgeRegister', data)
      // eslint-disable-next-line no-undef
      esp.setBackgroundColor('#000000')
      // eslint-disable-next-line no-undef
      esp.setBackgroundOpacity('0.6')
      // eslint-disable-next-line no-undef
      esp.setDescription('<p style="color:black;background-color:#FFFFFF">화면에 스탬프를 찍어 주세요.<br/>닫기 버튼(X)이 보이지 않을 경우<br/> 어두운 바탕으로 이동해 보세요.</p>')
      // eslint-disable-next-line no-undef
      esp.setLoadingYn('Y')
      // eslint-disable-next-line no-undef
      esp.setIconYn('Y')
      // eslint-disable-next-line no-undef
      esp.showEchossCertificationPage({
        // eslint-disable-next-line no-undef
        regionCode: esp.REGION_CODE_TYPE.KOREA,
        // eslint-disable-next-line no-undef
        languageCode: esp.LANGUAGE_CODE_TYPE.KOREAN,
        userCode: 'stamptour',
        licenseId: 'p6d441067c76f43bdb5767dee1b85d742',
        authKey: '',
        extData: { }
      }, function (errorCode, errorMessage) {
        alert('스템프 인증 호출에 실패하였습니다.')
      })
      // eslint-disable-next-line no-undef
      esp.certSuccess = (result) => {
        if (result.merchant) {
          if (result.merchant === data.mingle_merchant_code) {
            var today = new Date()
            var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
            var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
            var dateTime = date + ' ' + time
            this.$store.dispatch('loadStampUserApply', data, dateTime)
            this.$store.dispatch('loadBadgeRegister', data).then(() => {
              if (/Android/i.test(navigator.userAgent)) {
                // eslint-disable-next-line no-undef
                tranggle3.tranggle_callback('stamp_get', '{}')
              } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                window.location = 'tranggle_callback://stamp_get'
              } else {
                return false
              }
            })
          } else {
            alert('찍은 전자 스탬프 정보가 다릅니다.')
          }
        } else {
          alert('merchant 코드가 없습니다.')
        }
      }
      // eslint-disable-next-line no-undef
      esp.certError = (errorCode, errorMessage) => {
        console.log(errorCode)
        console.log(errorMessage)
      }
    },
    getTime () {
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
      const dateTime = date + ' ' + time
      return dateTime
    },
    scrollBottom () {
      if ((Math.ceil(window.scrollY + window.innerHeight) === document.body.scrollHeight || Math.floor(window.scrollY + window.innerHeight) === document.body.scrollHeight) && this.allStampCount > this.params.view_count) {
        if (this.mainStampList.length / this.params.page === 10) {
          this.params.page += 1
          this.$store.dispatch('loadMainData', this.params)
        }
      }
    },
    starIcon (star) {
      const starScore = (star === '0.0') ? 'n' : 'p'
      return require(`@/assets/images/star_${starScore}.png`)
    },
    nfcTest (e, data) {
      e.stopPropagation()
      if (/Android/i.test(navigator.userAgent)) {
        // eslint-disable-next-line no-undef
        tranggle3.tranggle_callback('stamp_nfc_read', '{}')
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        window.location = 'tranggle_callback://stamp_nfc_read'
      } else {
        return false
      }
    }
  },
  beforeCreate () {
    appEvent.trackProgress()
  },
  created () {
    window.addEventListener('scroll', this.scrollBottom)
    const appInfo = this.$route.query.AppVer
    const appVer = (appInfo) ? appInfo.split('B')[1] : ''
    this.appDevice = (appInfo) ? appInfo.split('_')[0] : ''
    this.appVersion = (appVer) ? parseInt(appVer.split('.').join('')) : ''
  },
  mounted () {
    if (this.mingleCode) {
      this.$store.dispatch('loadAreaList')
      this.$store.dispatch('loadMingleVersionChk')
      this.$store.dispatch('loadMainData', this.params)
    }
    // window.onpopstate = history.onpushstate = (e) => {
    //   if (window.location.href.split('/').pop().indexOf('modal') === -1) {
    //     // this.$store.dispatch('openPopupGift', {})
    //   }
    // }
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollBottom)
    this.$store.state.mainStampList = []
  }
}
</script>
<style>
.nfc_popup {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    z-index: 999;
    padding: 0 20px;
}
.nfc_popup .contents {
    width: 100%;
    background-color: #fff;
    text-align: center;
}
.nfc_popup .contents p {
    padding: 20px;
    text-align: center;
}
.nfc_popup .contents span {
    background-color: #cc705c;
    display: inline-block;
    margin-bottom: 10px;
    padding: 5px;
    color: #fff;
}
.nfc_popup .contents button {
    width: 100%;
    height: 40px;
    color: #fff;
    background-color: #cc705c;
}
.area_box .select {
    padding: 0;
}
</style>
